/**
 * EAA-1820: presentational cell primitives shared by both account tables. Each
 * context maps its OWN status vocabulary onto the generic `tone` here — realm:
 * enabled/pending-first-login/disabled; org: ok/pending/sync-error/revoked — the
 * mapping stays in each context's table (it is domain logic), only the rendered
 * dot+label widget is shared.
 */

import { initialsOf, type CellTone } from './cellHelpers';

export type { CellTone } from './cellHelpers';

export function StatusChip({ tone, label }: { tone: CellTone; label: string }) {
    return (
        <span className={`acc-status acc-status--${tone}`}>
            <span className="acc-status__dot" aria-hidden="true" />
            {label}
        </span>
    );
}

/** "Tài khoản" column: avatar-initials + primary/secondary text, optionally a button. */
export function IdentityCell({
    primary,
    secondary,
    onClick,
}: {
    primary: string;
    secondary: string;
    onClick?: () => void;
}) {
    const content = (
        <>
            <span className="portal-accounts-avatar" aria-hidden="true">
                {initialsOf(primary || secondary)}
            </span>
            <span className="portal-accounts-identity-text">
                <span className="portal-accounts-username">{primary || '—'}</span>
                <span className="portal-accounts-email">{secondary || '—'}</span>
            </span>
        </>
    );
    if (!onClick) {
        return <span className="portal-accounts-identity">{content}</span>;
    }
    return (
        <button type="button" className="portal-accounts-identity" onClick={onClick}>
            {content}
        </button>
    );
}
